module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/LTE#2-f7a99551bdb811be062f4651933e75aef7a26c05396ab767def5568c2e8f7314.svg";